<div class="permission-selector-container" [formGroup]="permissionForm">
  <!-- Grant Permission Dropdown -->
  <div class="permission-field">
    <mat-label class="card-label">Grant Permission<span>*</span></mat-label>
    <mat-form-field appearance="outline" class="custom-width-height" style="width: 100%;">
      <mat-select 
        [disableOptionCentering]="true" 
        panelClass="matselectopenPermissionpanel" 
        multiple="true"
        placeholder=" Select permissions " 
        class="selectDetails" 
        formControlName="userRoles" 
        #mySelects
        style="margin-top: -6px;height: 17px;"
        (selectionChange)="setPermissions($event.value)">
        
        <mat-option *ngFor="let option of visiblePermissions"
          [matTooltip]="getPermissionTooltip(option)"
          [value]="option">
          {{option.permission}}
        </mat-option>
        
        <mat-option class="no-checkbox sticky-option" disabled>
          <div class="option-footer">
            <button mat-stroked-button class="dropdown-button"
              [ngClass]="{'dropdown-ok-button': this.permissionForm.get('userRoles')?.value?.length > 0}"
              (click)="close(mySelects, $event)">
              <ng-container *ngIf="this.permissionForm.get('userRoles')?.value?.length > 0; else dropDownButton">
                <span>Ok</span>
              </ng-container>
              <ng-template #dropDownButton>
                <span>Close</span>
              </ng-template>
            </button>
          </div>
        </mat-option>
      </mat-select>
      
      <mat-error *ngIf="permissionForm.get('userRoles')?.hasError('required') && (permissionForm.get('userRoles')?.touched || permissionForm.get('userRoles')?.dirty)
        && this.permissionForm.get('userRoles')?.value?.length === 0"
        class="error-messages">
        Permission is required
      </mat-error>
    </mat-form-field>
  </div>

  <!-- Grant Access Dropdown -->
  <div class="access-field">
    <mat-label class="card-label">Grant Access</mat-label>
    <mat-form-field appearance="outline" class="custom-width-height" style="width: 100%;">
      <mat-select 
        [disableOptionCentering]="true" 
        panelClass="matselectopenPermissionpanel" 
        multiple="true"
        placeholder=" Select access " 
        class="selectDetails" 
        formControlName="userControls" 
        #mySelect
        style="margin-top: -6px;height: 17px;">
        
        <mat-option *ngFor="let option of accessPermissions" 
          [value]="option"
          [disabled]="(userFeatures.allocated || userFeatures.sub_budget_allocation) && option.level === userCanDeposit">
          {{ option.permission }}
        </mat-option>
        
        <mat-option class="no-checkbox sticky-option" disabled>
          <div class="option-footer">
            <button mat-stroked-button class="dropdown-button"
              [ngClass]="{'dropdown-ok-button': this.permissionForm.get('userControls')?.value?.length > 0}"
              (click)="close(mySelect, $event)">
              <ng-container *ngIf="this.permissionForm.get('userControls')?.value?.length > 0; else dropDownButton">
                <span>Ok</span>
              </ng-container>
              <ng-template #dropDownButton>
                <span>Close</span>
              </ng-template>
            </button>
          </div>
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
</div>
